import { makePath } from './routes';

export const getDefaultRoute = (workspaceId: string, tab?: string | null) => {
  const defaultTab = 'home';
  return makePath(['w', workspaceId, ...(tab ?? defaultTab).split('/')]);
};
